import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=3a56e58f&scoped=true&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=3a56e58f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56e58f",
  null
  
)

export default component.exports